import type {
    BadgesInProgressCollectionSectionContentModel,
    BadgesInProgressSectionContentModel,
    HeaderSectionContentModel,
    TabbedRewardsSectionContentModel,
} from '@/types/aem';
import {DynamicPageSectionItems} from '@/types/aem';

interface DynamicPageSectionBase {
    id?: string;
    order?: number;
}

interface DynamicPageSectionContentByType {
    [DynamicPageSectionItems.HeaderSection]: HeaderSectionContentModel;
    [DynamicPageSectionItems.BadgesInProgressSection]: BadgesInProgressSectionContentModel;
    [DynamicPageSectionItems.BadgesCollectionSection]: undefined;
    [DynamicPageSectionItems.BadgesInProgressCollectionSection]: BadgesInProgressCollectionSectionContentModel;
    [DynamicPageSectionItems.TabbedRewardsSection]: TabbedRewardsSectionContentModel | null;
}

type DynamicPageSectionByType = {
    [T in keyof DynamicPageSectionContentByType]: DynamicPageSectionBase & {
        type: T;
        content?: DynamicPageSectionContentByType[T];
    };
};

/**
 * Discriminated union of dynamic page sections.
 * Narrows `content` based on `type` in switch/if statements.
 *
 * Use this instead of the generated `DynamicPageSectionModel` which has a flat
 * content union that TypeScript cannot narrow.
 */
export type DynamicPageSectionModel = DynamicPageSectionByType[keyof DynamicPageSectionByType];

export const asDynamicPageSections = (sections: unknown[]): DynamicPageSectionModel[] =>
    sections as unknown as DynamicPageSectionModel[];
